import { getGameData } from 'shared';
import { FourBall_HandicapManager } from './FourBall_HandicapManager';
import { FourBall_ScoringManager } from "./FourBall_ScoringManager";
export class FourBall_GameManager {
    onTeamsChanged(handler) {
        this.teamsChangedHandler = handler;
    }
    getStrokePatternClassForHole(holeIndex) {
        return this.handicapManager?.getStrokePatternClassForHole(holeIndex) ?? "sp_0";
    }
    createHandicapManager(data) {
        if (!data.teams || !data.handicapSetup) {
            console.warn("[FourBall_GameManager] Cannot create handicap manager. FourBall data is incomplete.", data);
            return;
        }
        const players = (this.rc.roster ?? []).map(player => ({
            memberId: player.id,
            displayCode: player.displayCode ?? player.nickName ?? player.id,
            handicap: player.handicap ?? 0,
        }));
        const args = {
            teams: {
                team1: [...data.teams.team1],
                team2: [...data.teams.team2],
            },
            handicapSetup: data.handicapSetup,
            players,
            holesInRound: this.rc.holesInRound,
            holeHandicaps: this.rc.handicaps,
        };
        this.handicapManager = new FourBall_HandicapManager(args);
    }
    createScoringManager(data) {
        if (!this.handicapManager || !data.teams) {
            console.warn("[FourBall_GameManager] Cannot create scoring manager.", data);
            return;
        }
        this.scoringManager = new FourBall_ScoringManager(this.rc, this.gc, this.handicapManager, data.teams);
    }
    constructor(rc, gc) {
        this.name = "Four Ball";
        this.pars = [];
        this.handicaps = [];
        this.players = [];
        this.totalStrokes = 0;
        this.id = '';
        this.header = '';
        this.scorecardPlayers = '';
        this.rc = rc;
        this.gc = gc;
        this.header = gc.header ?? "4 Ball";
        this.players = (gc.players ?? [])
            .map(p => p.id)
            .filter((id) => Boolean(id));
    }
    get isConfigured() {
        return Boolean(this.header && this.header !== "4 Ball");
    }
    getHeaderElementId() {
        return "fourBallHeader";
    }
    getHeaderCssClasses() {
        return this.isConfigured
            ? ["four-ball-header"]
            : ["four-ball-header", "four-ball-needs-setup"];
    }
    getHeaderTitle() {
        return this.isConfigured
            ? "4-Ball teams"
            : "Click to set 4-Ball teams";
    }
    getHeaderClickHandler() {
        return () => {
            this.showTeamSelectionDialog();
        };
    }
    showTeamSelectionDialog() {
        const roster = this.rc.roster ?? [];
        if (roster.length < 4) {
            alert("4 Ball requires 4 players.");
            return;
        }
        const existing = document.getElementById("fourBallTeamDialog");
        existing?.remove();
        const overlay = document.createElement("div");
        overlay.id = "fourBallTeamDialog";
        overlay.style.cssText = `
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    `;
        const panel = document.createElement("div");
        panel.style.cssText = `
        background: white;
        padding: 18px;
        border-radius: 8px;
        min-width: 360px;
        font-family: Arial, sans-serif;
    `;
        panel.innerHTML = `
        <h3 style="margin-top:0;">Select 4 Ball Teams</h3>

        <table style="width:100%; margin-bottom:12px; border-collapse:collapse;">
            <tr>
                <td style="white-space:nowrap; font-weight:bold; padding:4px;">Team 1:</td>
                <td style="padding:4px;"><select id="fb_t1p1">${this.buildPlayerOptions()}</select></td>
                <td style="padding:4px;"><select id="fb_t1p2">${this.buildPlayerOptions()}</select></td>
            </tr>
            <tr>
                <td style="white-space:nowrap; font-weight:bold; padding:4px;">Team 2:</td>
                <td style="padding:4px;"><select id="fb_t2p1">${this.buildPlayerOptions()}</select></td>
                <td style="padding:4px;"><select id="fb_t2p2">${this.buildPlayerOptions()}</select></td>
            </tr>
        </table>
        <div style="border-top:1px solid #ddd; margin-top:12px; padding-top:12px;">

            <div style="display:grid; grid-template-columns:22px 1fr; gap:8px; align-items:start; margin-bottom:10px;">
                <input
                    type="radio"
                    name="fbHandicapMode"
                    value="usga"
                    style="width:auto; margin-top:2px;"
                />
            <div>
            <div style="font-weight:bold;">Use Player Handicaps</div>
            <div id="fbUsgaOptions" style="margin-top:6px;">
                <label for="fbHandicapPercent" style="font-size:14px;">Percentage:</label>
                <select id="fbHandicapPercent" style="margin-left:6px;">
                    <option value="100">100%</option>
                    <option value="90">90%</option>
                    <option value="85">85%</option>
                    <option value="80">80%</option>
                </select>
            </div>
        </div>

        <input
            type="radio"
            name="fbHandicapMode"
            value="custom"
            style="width:auto; margin-top:2px;"
        />
        <div>
            <div style="font-weight:bold;">Use Team Handicaps (or scratch)</div>
            <div id="fbCustomOptions" style="display:none; margin-top:6px;">
                <div style="display:grid; grid-template-columns:auto 60px; gap:6px 8px; align-items:center;">
                    <label for="fbTeam1Handicap">Team 1:</label>
                    <input id="fbTeam1Handicap" type="number" min="0" value="0" style="width:55px;" />

                    <label for="fbTeam2Handicap">Team 2:</label>
                    <input id="fbTeam2Handicap" type="number" min="0" value="0" style="width:55px;" />
                </div>

                <div style="font-size:12px; color:#666; margin-top:4px;">
                    Use 0 / 0 for scratch.
                </div>
            </div>
        </div>
    </div>

</div>

        <div style="text-align:right;">
            <button id="fbCancelBtn" type="button">Cancel</button>
            <button id="fbSaveBtn" type="button">Save</button>
        </div>
    `;
        overlay.appendChild(panel);
        document.body.appendChild(overlay);
        document
            .getElementById("fb_t1p1")
            ?.addEventListener("change", () => this.updateTeam2FromTeam1());
        document
            .getElementById("fb_t1p2")
            ?.addEventListener("change", () => this.updateTeam2FromTeam1());
        const updateHandicapOptions = () => {
            const mode = this.getRadioValue("fbHandicapMode");
            const usgaOptions = document.getElementById("fbUsgaOptions");
            const customOptions = document.getElementById("fbCustomOptions");
            if (usgaOptions)
                usgaOptions.style.display = mode === "usga" ? "block" : "none";
            if (customOptions)
                customOptions.style.display = mode === "custom" ? "block" : "none";
        };
        document
            .querySelectorAll('input[name="fbHandicapMode"]')
            .forEach(radio => radio.addEventListener("change", updateHandicapOptions));
        this.updateTeam2FromTeam1();
        updateHandicapOptions();
        document.getElementById("fbCancelBtn")?.addEventListener("click", () => {
            overlay.remove();
        });
        document.getElementById("fbSaveBtn")?.addEventListener("click", () => {
            if (this.saveSelectedTeams()) {
                overlay.remove();
            }
        });
    }
    updateTeam2FromTeam1() {
        const t1p1 = document.getElementById("fb_t1p1")?.value;
        const t1p2 = document.getElementById("fb_t1p2")?.value;
        const t2p1 = document.getElementById("fb_t2p1");
        const t2p2 = document.getElementById("fb_t2p2");
        if (!t1p1 || !t1p2 || !t2p1 || !t2p2)
            return;
        if (t1p1 === t1p2)
            return;
        const remainingPlayers = (this.rc.roster ?? [])
            .map(p => p.id)
            .filter(id => id !== t1p1 && id !== t1p2);
        if (remainingPlayers.length !== 2)
            return;
        t2p1.value = remainingPlayers[0];
        t2p2.value = remainingPlayers[1];
    }
    buildPlayerOptions() {
        return (this.rc.roster ?? [])
            .map(p => {
            const label = p.displayCode ?? p.nickName ?? p.id;
            return `<option value="${this.escapeHtml(p.id)}">${this.escapeHtml(label)}</option>`;
        })
            .join("");
    }
    saveSelectedTeams() {
        const t1p1 = this.getSelectValue("fb_t1p1");
        const t1p2 = this.getSelectValue("fb_t1p2");
        const t2p1 = this.getSelectValue("fb_t2p1");
        const t2p2 = this.getSelectValue("fb_t2p2");
        const selected = [t1p1, t1p2, t2p1, t2p2];
        if (selected.some(id => id === "")) {
            alert("All four team player selections are required.");
            return false;
        }
        if (new Set(selected).size !== 4) {
            alert("Each player can only be selected once.");
            return false;
        }
        const handicapMode = this.getRadioValue("fbHandicapMode");
        let handicapPercent;
        let team1Handicap;
        let team2Handicap;
        if (handicapMode === "usga") {
            handicapPercent = this.getNumberValue("fbHandicapPercent");
            if (!Number.isFinite(handicapPercent) || handicapPercent <= 0) {
                alert("Select a valid handicap percentage.");
                return false;
            }
        }
        else {
            team1Handicap = this.getNumberValue("fbTeam1Handicap");
            team2Handicap = this.getNumberValue("fbTeam2Handicap");
            if (!Number.isFinite(team1Handicap) ||
                !Number.isFinite(team2Handicap) ||
                team1Handicap < 0 ||
                team2Handicap < 0) {
                alert("Team handicaps must be zero or greater.");
                return false;
            }
        }
        this.players = selected;
        this.header = `★${this.getDisplayCode(t1p1)}${this.getDisplayCode(t1p2)}-${this.getDisplayCode(t2p1)}${this.getDisplayCode(t2p2)}`;
        const headerEl = document.getElementById(this.getHeaderElementId());
        if (headerEl) {
            headerEl.classList.remove("four-ball-needs-setup");
            headerEl.title = "4-Ball teams";
        }
        const payload = {
            team1Player1: t1p1,
            team1Player2: t1p2,
            team2Player1: t2p1,
            team2Player2: t2p2,
            header: this.header,
            handicapMode,
            handicapPercent,
            team1Handicap,
            team2Handicap,
        };
        void this.teamsChangedHandler?.(payload);
        return true;
    }
    getSelectValue(id) {
        const el = document.getElementById(id);
        return el?.value ?? "";
    }
    getRadioValue(name) {
        const el = document.querySelector(`input[name="${name}"]:checked`);
        return el?.value ?? "";
    }
    getNumberValue(id) {
        const el = document.getElementById(id);
        return Number(el?.value ?? 0);
    }
    getDisplayCode(playerId) {
        const player = this.rc.roster?.find(p => p.id === playerId);
        return player?.displayCode ?? player?.nickName ?? playerId;
    }
    escapeHtml(value) {
        return value
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
    }
    getHoleWinnerCssClass(holeIndex, playerScores) {
        if (this.scoringManager?.isMatchOver(holeIndex, playerScores)) {
            return "";
        }
        return this.scoringManager?.getHoleWinnerCssClass(holeIndex, playerScores) ?? "";
    }
    /**
     * Provide the score in different formats.
     */
    getScore(displayType, holeIndex, playerScores, currentPlayerId) {
        return this.scoringManager?.getScore(displayType, holeIndex ?? 0, playerScores, currentPlayerId) ?? "";
    }
    getSummaryLine(holeIndex, detailed) {
        return "Fourball Summary Line";
    }
    reset() {
        throw new Error('Method not implemented.');
    }
    static CreateGameManagers(rc, storedScorecard) {
        const players = FourBall_GameManager.buildPlayers(rc);
        const fourBallData = getGameData(storedScorecard, "Four Ball");
        const header = fourBallData.teams
            ? FourBall_GameManager.buildHeaderFromTeams(rc, fourBallData.teams)
            : "4 Ball";
        const gc = {
            players,
            header: header,
            scoreDisplaysByHole: Array(rc.holesInRound).fill(null),
            skinsCarriedForward: 0,
        };
        const manager = new FourBall_GameManager(rc, gc);
        if (fourBallData?.teams) {
            manager.createHandicapManager(fourBallData);
            manager.createScoringManager(fourBallData);
        }
        return [manager];
    }
    static buildHeaderFromTeams(rc, teams) {
        const display = (memberId) => rc.roster.find(r => r.id === memberId)?.displayCode ?? "?";
        return `★${display(teams.team1[0])}${display(teams.team1[1])}-${display(teams.team2[0])}${display(teams.team2[1])}`;
    }
    static buildPlayers(rc) {
        const holes = rc.holesInRound;
        return (rc.roster ?? []).map((entry, rosterIndex) => ({
            rosterIndex,
            nickName: entry.nickName,
            displayCode: entry.displayCode,
            id: entry.id,
            // Unknown until teams are selected
            strokesReceived: 0,
            strokesPerHole: Array(holes).fill(0),
            cumulativeGrossScore: Array(holes).fill(0),
            cumulativeNetScore: Array(holes).fill(0),
        }));
    }
    static getGameSummaries(managers, holeIndex, playerScores) {
        const fourBallManager = managers.find((gm) => gm instanceof FourBall_GameManager);
        if (!fourBallManager) {
            return undefined;
        }
        return fourBallManager.scoringManager?.getGameSummary(holeIndex, playerScores);
    }
    static getAvGameSummary(managers, holeIndex, playerScores) {
        const summary = this.getGameSummaries(managers, holeIndex, playerScores);
        if (!summary) {
            return {
                fourBall: {
                    manifest: {
                        status: "unavailable",
                        message: "Teams are not configured.",
                    },
                    data: null,
                },
            };
        }
        return {
            fourBall: {
                manifest: {},
                data: summary,
            },
        };
    }
    /**
     * Returns one consolidated Four-Ball score line for all FourBall managers.
     *
     * This matches the same static aggregation contract used by Match Play and
     * Stroke Play. Four-Ball scoring is still mostly placeholder logic in this
     * file, so this method preserves the existing per-player summary behavior
     * and only changes the method name, signature, filtering, and prefix.
     */
    static getAllScoresForGameType(displayScoreType, managers, holeIndex, playerScores, currentPlayerId) {
        const fourBallManagers = managers.filter((gm) => gm instanceof FourBall_GameManager);
        const line = fourBallManagers
            .filter((gm) => !currentPlayerId || gm.includesPlayer(currentPlayerId))
            .map(gm => gm.getScore(displayScoreType, holeIndex, playerScores, currentPlayerId))
            .filter((line) => typeof line === "string" && line !== "")
            .join(" | ");
        return line ? `FB: ${line}` : "";
    }
    /** True if this manager involves the given player initial. */
    includesPlayer(id) {
        return this.players.includes(id)
            || (this.scoringManager?.includesPlayer(id) ?? false);
    }
    getHeaderDisplay() {
        return this.header;
    }
    getStrokesOnHole(holeIndex) {
        return this.handicapManager?.holeHasAnyStroke(holeIndex) ? 1 : 0;
    }
    getGameContext() {
        return this.gc;
    }
    onHoleScore(fc) {
        return "";
    }
    getDisplayValue(holeIndex) {
        // For four-ball display the best (lowest) individual stroke on the hole
        const gc = this.gc;
        if (!gc || !Array.isArray(gc.players) || gc.players.length === 0)
            return '';
        let best = Number.POSITIVE_INFINITY;
        for (const p of gc.players) {
            const s = p?.strokesPerHole ? p.strokesPerHole[holeIndex] : undefined;
            if (typeof s === 'number' && !Number.isNaN(s) && s < best)
                best = s;
        }
        return best === Number.POSITIVE_INFINITY ? '' : String(best);
    }
    getHeaderRender() {
        if (!this.isConfigured) {
            return {
                cssClass: "four-ball-header four-ball-needs-setup",
                text: this.header,
            };
        }
        const header = this.header.replace(/^★/, "");
        const parts = header.split("-");
        if (parts.length !== 2) {
            return {
                cssClass: "four-ball-header",
                text: this.header,
            };
        }
        const team1Code = this.escapeHtml(parts[0]);
        const team2Code = this.escapeHtml(parts[1]);
        return {
            cssClass: "four-ball-header",
            html: `★<span class="winner-a-header">${team1Code}</span>-<span class="winner-b-header">${team2Code}</span>`,
        };
    }
    getScoreCellRender(holeIndex, playerIndex, playerScores) {
        const cssClass = this.getHoleWinnerCssClass(holeIndex, playerScores);
        if (!cssClass) {
            return undefined;
        }
        if (cssClass === "fb-team1-win") {
            return { cssClass: "winner-a-dot" };
        }
        if (cssClass === "fb-team2-win") {
            return { cssClass: "winner-b-dot" };
        }
        return undefined;
    }
}
//# sourceMappingURL=FourBall_GameManager.js.map